// src/components/authentication/ProtectedRoute.js
import { useMembershipAccess } from '../hooks/membership';
import PurchaseMembershipBlock from '../pages/payment/PurchaseMembershipBlock';
import { useLocation } from 'react-router-dom';

const ProtectedRoute = ({ allowedMemberships, children }) => {
  const membership = useMembershipAccess();
  const location = useLocation();

  if (membership.loading) {
    return <div className="flex justify-center items-start h-full"></div>;
  }

  const hasAccess = membership.hasActiveMembershipAccess(allowedMemberships);

  if (hasAccess) {
    return children;
  }

  return (
    <div className="flex justify-center items-start h-full">
      <PurchaseMembershipBlock intendedRoute={`${location.pathname}${location.search || ''}`} />
    </div>
  );
};

export default ProtectedRoute;
